export default __webpack_public_path__ + "static/media/HR.dbc52616.png";